import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dbf1a30c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stake-nominate__controls" }
const _hoisted_2 = { class: "stake-nominate__controls-sort" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sort by:", -1))
const _hoisted_4 = { class: "stake-nominate__controls-filter" }
const _hoisted_5 = { class: "stake-nominate__controls-filter-block" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Hide high risk validators", -1))
const _hoisted_7 = { class: "stake-nominate__controls-filter-block" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Only show selected", -1))

import InfoTooltip from "@/components/info-tooltip/index.vue";
import Switch from "@/components/switch/index.vue";
import BaseSelect from "@/components/base-select/index.vue";
import { BaseSelectItem } from "@/types/base-select";
import { ref } from "vue";

const rewardsInfo =
  "Rewards will be credited to your bonded balance for compound earning.";


export default /*#__PURE__*/_defineComponent({
  __name: 'stake-nominate-controls',
  props: {
  isHighRisk: {
    type: Boolean,
    default: false,
  },
  isOnlySelected: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:high-risk", "update:only-selected", "update:sort"],
  setup(__props, { emit }) {

const sort = ref<BaseSelectItem>({
  id: 0,
  name: "Estimated returns",
});

const sortOptions = [
  {
    id: 0,
    name: "Estimated returns",
  },
  {
    id: 1,
    name: "Validator name",
  },
];





const highRiskSwitch = (isChecked: boolean) => {
  emit("update:high-risk", isChecked);
};

const onlySelectedSwitch = (isChecked: boolean) => {
  emit("update:only-selected", isChecked);
};

const selectSort = (item: BaseSelectItem) => {
  sort.value = item;
  emit("update:sort", item);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(BaseSelect, {
        options: sortOptions,
        selected: sort.value,
        "onToggle:select": selectSort
      }, null, 8, ["selected"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(InfoTooltip, { text: rewardsInfo }),
        _createVNode(Switch, {
          "is-checked": __props.isHighRisk,
          "onUpdate:check": highRiskSwitch
        }, null, 8, ["is-checked"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(Switch, {
          "is-checked": __props.isOnlySelected,
          "onUpdate:check": onlySelectedSwitch
        }, null, 8, ["is-checked"])
      ])
    ])
  ]))
}
}

})